import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  requestStudentOnboardPaths,
  receiveStudentOnboardPaths,
  handleStudentOnboardPathsError,
  resetStudentOnboardPaths,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_STUDENT_ONBOARD_PATHS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_STUDENT_ONBOARD_PATHS:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.STUDENT_ONBOARD_PATHS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.STUDENT_ONBOARD_PATHS_RESET:
      return {
        ...state,
        data: null,
      };
    default:
      return state;
  }
};

export const fetchPaths = student_uuid => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestStudentOnboardPaths());
  try {
    return fetch(`${API.student.paths}?student_uuid=${student_uuid}`, config)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveStudentOnboardPaths(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentOnboardPathsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentOnboardPathsError(err));
  }
};

export const fetchActivePaths = student_uuid => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestStudentOnboardPaths());
  try {
    return fetch(
      `${API.student.student_active_paths}?student_uuid=${student_uuid}`,
      config
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        dispatch(receiveStudentOnboardPaths(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentOnboardPathsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentOnboardPathsError(err));
  }
};

export const resetStudentOnboardPath = () => dispatch => {
  dispatch(resetStudentOnboardPaths());
};
